import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { BiodataCacheProvider } from './context/BiodataCacheContext';
import { NotificationProvider } from './context/NotificationContext';
import { ConfirmProvider } from './context/ConfirmContext';
import AppRoutes from './Routes';
import ScrollToTop from './components/ScrollToTop';
import MaintenancePage from './pages/MaintenancePage';

function App() {
  const isMaintenanceMode = false; // import.meta.env.VITE_MAINTENANCE_MODE === 'true';

  if (isMaintenanceMode) {
    return (
      <Router>
        <MaintenancePage />
      </Router>
    );
  }

  return (
    <Router>
      <NotificationProvider>
        <ConfirmProvider>
          <AuthProvider>
            <DataProvider>
              <BiodataCacheProvider>
                <ScrollToTop />
                <AppRoutes />
              </BiodataCacheProvider>
            </DataProvider>
          </AuthProvider>
        </ConfirmProvider>
      </NotificationProvider>
    </Router>
  );
}

export default App;
